import React from "react";
import { Card, Select, Typography } from "antd";
import { AdminMenuLayout } from "../../../shared/components";
import { storesService } from "../../../shared/services";
import { StoreShippingRatesPanel } from "./StoreShippingRatesPanel";

const { Text, Title } = Typography;

export const ShippingRates = () => {
  const [stores, setStores] = React.useState<any[]>([]);
  const [storeId, setStoreId] = React.useState<number | null>(null);
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    setLoading(true);
    storesService
      .find({ query: { $limit: 200, $sort: { name: 1 } } })
      .then((res) => {
        const data = "data" in res ? res.data : res;
        const list = Array.isArray(data) ? data : [];
        setStores(list);
        if (list.length > 0) {
          setStoreId(list[0].id);
        }
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <AdminMenuLayout pageDescription="Tarifas de envío" title="Tarifas de envío">
      <Card
        loading={loading}
        style={{
          borderRadius: 12,
          border: "none",
          boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
          marginBottom: 16,
        }}
        bodyStyle={{ padding: 24 }}
      >
        <Title level={4} style={{ margin: 0, marginBottom: 8 }}>
          Selecciona una sede
        </Title>
        <Text type="secondary" style={{ display: "block", marginBottom: 16 }}>
          Cada sede puede tener su propio modo de domicilio (barrios o
          kilómetros). También puedes configurarlo al editar la sede.
        </Text>
        <Select
          style={{ width: "100%", maxWidth: 420 }}
          placeholder="Elegir sede"
          value={storeId ?? undefined}
          onChange={(value) => setStoreId(value)}
          options={stores.map((store) => ({
            value: store.id,
            label: store.name,
          }))}
        />
      </Card>

      {storeId ? <StoreShippingRatesPanel storeId={storeId} /> : null}
    </AdminMenuLayout>
  );
};
